import { createSelector } from '@reduxjs/toolkit';
import { computersForMap } from './computers-for-map';

export const computersOffNhn = createSelector(computersForMap, function (computers) {
  //        console.log('computersOffNhn', list);
  return computers.filter(function (c) {
    return c.unitType !== 'computer' && c.unitType !== 'printer' && c.unitType !== '' && c.connectionType === 'OTHER';
  });
});
